<template>
    <div class="item">
        <template v-if="headersMode">
            <div class="header" :style="{ width: firstColWidth }">
                <span>&nbsp;</span>
            </div>
            <div
                class="header"
                v-for="(column, index) in visibleColumns"
                :key="index" 
                :style="{ width: column.width }"
                @click="setSortBy(column.name)"
            >
                <span class="text">
                    {{ column.label }}
                </span>
                <template v-if="!terms && column.name === sortByName">
                    <span class="icon far fa-chevron-up" v-if="sortByDir === 'asc'"></span>
                    <span class="icon far fa-chevron-down" v-else></span>
                </template>
            </div>
            <div class="header" :style="{ width: lastColWidth }"></div>
        </template>
        <template v-else>
            <div class="column" :style="{ width: firstColWidth }">
                <span v-if="contact.protectionEnabled" class="far fa-lock-alt" title="PIN protection enabled"
                    >&nbsp;</span
                >
            </div>
            <div class="column" v-for="(column, index) in visibleColumns" :key="index" :style="{ width: column.width }">
                <div class="text" :title="contact[column.name]">
                    {{ contact[column.name] }}
                </div>
            </div>
            <div class="column" :style="{ width: lastColWidth }">
                <div
                    class="edit"
                    @click="$store.dispatch('dataElementsList/addEditDialog', { data: contact, definition })"
                >
                    Edit
                </div>
            </div>
        </template>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { strings } from '../../utils';

    export default {
        name: 'ContactListItem',
        data() {
            return {
                firstColWidth: '15px',
                lastColWidth: '100px',
            };
        },
        props: {
            item: {
                // if no item, make headers
                type: Object,
            },
        },
        computed: {
            ...mapGetters({
                definition: 'dataElementsList/getDefinition',
                sortBy: 'dataElementsList/getSortBy',
                terms: 'dataElementsList/getTerms',
            }),
            maxWidth() {
                return (
                    this.$store.getters['page/width'] -
                    this.$store.getters['layout/dimensions'].widthLeftBar -
                    parseInt(this.firstColWidth) -
                    parseInt(this.lastColWidth) -
                    25
                );
            },
            contact() {
                return this.item;
            },
            headersMode() {
                return !this.item;
            },
            columns() {
                let columns = [
                    {
                        label: 'First Name',
                        name: 'fname',
                        width: '100px',
                    },
                    {
                        label: 'Last Name',
                        name: 'lname',
                        width: '100px',
                    },
                    {
                        label: 'Email',
                        name: 'email',
                        width: '200px',
                    },
                ];

                let remainingColumns = this.definition.schema.reduce((acc, def) => {
                    let colExists = columns.find((col) => def.name === col.name);
                    if (colExists || !def.linkable) return acc;

                    acc.push({
                        label: def.label,
                        name: def.name,
                        width: strings.pixelate(Math.min(def.size * 3, 100)),
                    });
                    return acc;
                }, []);

                columns.push(...remainingColumns);

                return columns;
            },
            visibleColumns() {
                let numCols = 0;

                this.columns.reduce((accWidth, col) => {
                    accWidth += parseInt(col.width);
                    if (accWidth < this.maxWidth) numCols++;
                    return accWidth;
                }, 0);

                return [...this.columns].splice(0, numCols);
            },
            sortByName() {
                return this.sortBy.length === 1 ? this.sortBy[0].name : null;
            },
            sortByDir() {
                return this.sortBy.length === 1 ? this.sortBy[0].direction : null;
            },
        },
        methods: {
            setSortBy(name) {
                let direction = this.sortByDir === 'desc' || name !== this.sortByName ? 'asc' : 'desc';
                this.$store.commit('dataElementsList/setSortBy', [{ name, direction }]);
                this.$store.commit('dataElementsList/setPageIndex', 0);
                this.load();
            },
            async load() {
                this.$store.commit('dataElementsList/setDefinitionId', this.$route.params.defId);
                await this.$store.dispatch('dataElementsList/load');
            },
        },
    };
</script>
<style lang="scss" scoped>
    .item {
        @include flex-split;
        height: 35px;
        position: relative;
        transition: border-color 0.2s, background-color 0.2s;
        padding: 0.15em 0.5em;
        border: 1px solid transparent;
        border-left: none;
        border-right: none;
        border-top-color: $color-disabled-bg;

        &:first-child {
            border-top: none;
        }

        &.clickable {
            cursor: pointer;

            &:hover {
                background: #f1f1f1;
            }
        }

        > div {
            height: 100%;
            display: flex;
            align-items: flex-start;
            flex-direction: column;
            justify-content: center;

            &.split {
                justify-content: space-between;
            }
        }

        .column,
        .header {
            &:first-child {
                justify-content: space-between;
                align-items: center;
                flex-direction: row;
            }
        }

        .column:last-child {
            align-items: flex-end;
        }

        .header {
            user-select: none;
            width: 100px;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;

            .text {
                padding-right: 0.5em;
            }

            .icon {
                color: $color-inactive-text;
            }
        }
    }

    .edit {
        @extend a;
        user-select: none;
    }

    .column .text {
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>